import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/ManageAccount/Views/manage-account.html";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import Pager from "@/Pages/Admin/Modules/Common/Controllers/Pager";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";


@WithRender
@Component({
  components: {
    Pager
  }
})
export default class ManageAccount extends Vue {
  protected ui: any = {};
  protected errors: any = {};
  protected errorsMessage: any = {};
  protected errorsModal: any = {};
  protected isError: boolean = false;
  protected RequestList: any = [];
  protected ApprovedTypeList: any = [];
  protected AllocatedService: any = [];
  protected SearchBy: any = {};
  protected paging: any = {};
  protected Status: any = {};
  protected Comment: any = {};
  protected SelectedAccount: any = {};
  protected Note: any = '';
  protected ServiceList: any = [];
  protected allSelected: boolean = false;
  constructor() {
    super();
    this.ui.IsLoading = false;
    this.ui.PostLoading = false;

    this.paging.current_page = 1;
    this.paging.last_page = 1;
    this.paging.per_page = 0;

    this.SearchBy.Username = "";
    this.SearchBy.Email = "";
    this.SearchBy.Status = "";
    this.Status.DisableVerify = false;

    this.Status.ShowTextEnable = false;
    this.Status.ShowTextDisable = false;
    this.Status.ShowEnableModal = false;
    this.Status.ShowDisableModal = false;
    this.Status.SelectAll = false;
    // v-model="request.SelectAll" @click.prevent="selectAll(request)"
    this.Status.Verify = false;

    this.Comment.Enable = "";
    this.Comment.Disable = "";
    this.SelectedAccount.Data = {};
    this.SelectedAccount.Index = '';
    
    this.RequestList = [
      // { id: "Trek", name: "Trek" },
      // { id: "Hotel", name: "Hotel" },
      // { id: "Flight", name: "Flight" },
      // { id: "Homestay", name: "Homestay" }
    ];
    this.ApprovedTypeList = [];
  }
  public mounted() {
    this.getServiceList();
    this.getAccountRequest();
  }
  public toggleFilter() {
    $(".filter-body").slideToggle("medium");
    $(".filter-head").toggleClass("up");
  }
  public getServiceList() {
    this.ui.IsLoading = true;
    trekService
      .servicesList()
      .then((res: any) => {
        // this.UnitList = res.data.data;
        // console.log("Services :", res.data.data);
        res.data.data.forEach((item: any) => {
          item.SelectAll = false;
        });
        this.ServiceList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }
  public getAccountRequest() {
    this.ui.IsLoading = true;
    let data = {

    };
    trekService
      .accountList(data)
      .then((res: any) => {
        // system_module
        // console.log("ACCOUT REQUEST LIST", res.data.data);
        res.data.data.forEach((item: any) => {
          if (item.account_modules.length) {
            item.account_modules.forEach((data: any) => {
              // console.log("ACCOUNT MODULE", data);
              if (data.system_module) {
                // console.log("Inside", data);
          //     data.system_module.forEach((data: any) => {
          //       console.log("Inside", item);
          // //       // if (data.system_module) {
                  data.SelectAll = false;
          // //       // }
          //     });
            }
          });
          }
        });
        this.RequestList = res.data.data;
        // console.log(this.RequestList);
        this.RequestList.forEach((item: any) => {
        if (item.is_approved === 0) {
          console.log("HELLO");
        }
      });
        this.ui.IsLoading = false;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      });
  }
  // public showSegmentModal() {
  //   $("#addSegment").modal("show");
  // }
  public check(request: any) {
    // console.log("CHECK", request);
    this.RequestList.forEach((item: any) => {
      if (item.SelectAll) {
        if (request.account_modules === item.account_modules) {
          // console.log("Inside", item.account_modules);
          item.account_modules.forEach((type: any) => {
            // console.log("CHECK HERE", type);
            // if (type.service === request.service) {
            type.service = true;
            // }
            // console.log("Inside", item);
          });
        }
      } else {
        if (request.account_modules === item.account_modules) {
          item.account_modules.forEach((type: any) => {
            // if (type.service === request.service) {
            item.SelectAll = false;
            // console.log("Inside", item);
            type.service = false;
            // }
          });
        }
      }
    });
    // return Math.random();
  }
  public checkType(serviceType: any) {
    console.log("Service Check", serviceType);
    if (serviceType.SelectAll) {
      this.AllocatedService = [];
      this.ServiceList.forEach((item: any) => {
        if (item.SelectAll === serviceType.SelectAll) {
          console.log("DATA HERE", item);
          this.AllocatedService.push({ code: item.code });
          // _this.item.operator_type.push({ code: value.code });
        //     item.SelectAll = false;
          }
      });
    } 
    else {
      // let total = 0;
      this.ServiceList.forEach((item: any, index: any) => {
        // ++total;
        if (item === serviceType) {
          // console.log("DATA",index);
          // console.log("Index", total-1);
          this.$delete(this.AllocatedService, index);
        // console.log("Deselect", item);
        }
    //     
    //     item.account_modules.forEach((type: any) => {
    //       if (type.service) {
    //         
    //         if (total === item.account_modules.length) {
    //           item.SelectAll = true;
    //         }
    //       }
    //     });
    //     // if(item.account_modules === ){
    //     // }
      });
    }
  }
  public selectAll() {
    // // this.RequestList
    console.log("Selected Index Data");
    // this.RequestList.forEach((item: any) => {
    //   if (item.id === request.id) {
    //     console.log("Inside", item);
    //     // item.SelectAll = true;
    //   }
    //   });
  }
  public verifyAccountRequest(request: any, index: any) {
    this.Status.DisableVerify = true;
    console.log("Selected Data", request.id);
    console.log("Selected Data", request);
    this.ui.PostLoading = true;
    let data = {
      id: request.id
    };
    trekService
      .accountRequestApprove(data)
      .then((res: any) => {
        console.log("Respose Data", res);
        this.ui.PostLoading = false;
        this.Status.DisableVerify = false;
        this.$set(this.RequestList, index, res.data.data);
        this.cancelDisable();
      })
      .catch((error: any) => {
        this.errors = error;
      });
  }
  public showEnableModal() {
    this.Status.ShowEnableModal = true;
  }
  public enable(request: any, index: any) {
    this.Status.ShowTextEnable = true;
    this.ui.PostLoading = true;
    let data = {
      id: request.id,
      comments: this.Comment.Enable
    };
    trekService
      .accountEnable(data)
      .then((res: any) => {
        console.log("Respose Data", res);
        this.ui.PostLoading = false;
        this.Status.ShowTextEnable = false;
        this.$set(this.RequestList, index, res.data.data);
        this.cancelEnable();
      })
      .catch((error: any) => {
        this.errors = error;
      });
  }
  public cancelDisable() {
    this.Status.ShowDisableModal = false;
    this.Comment.Enable = '';
  }
  public cancelEnable() {
    this.Status.ShowEnableModal = false;
    this.Comment.Disable = '';
  }
  // public verify() {
  //   this.Status.Verify = true;
  //   console.log("Verify Enable");
  // }
  public disable(request: any, index: any) {
    this.Status.ShowTextDisable = true;
    this.ui.PostLoading = true;
    let data = {
      id: request.id,
      comments: this.Comment.Disable
    };
    trekService
      .accountDisable(data)
      .then((res: any) => {
        console.log("Respose Data", res);
        this.ui.PostLoading = false;
        this.Status.ShowTextDisable = false;
        this.$set(this.RequestList, index, res.data.data);
      })
      .catch((error: any) => {
        this.errors = error;
      });
    console.log("Disable");
  }
  public selectAllTypes() {
    console.log("INSIDE");
    this.ApprovedTypeList = [];
    if (this.allSelected) {
      console.log("INSIDE ARRAY");
      this.RequestList.filter((type: any) => {
        this.ApprovedTypeList.push(type.id.toString());
        type.IsActive = true;
      });
    } else {
      this.RequestList.filter((type: any) => {
        this.ApprovedTypeList.push(type.id.toString());
        type.IsActive = false;
      });
    }
    // console.log("HELLO");
  }
  public select() {
    this.allSelected = false;
  }
  public onPaging(CurrentPage: number) {
    this.paging.current_page = CurrentPage;
    // this.PackageLists = {};
    this.getAccountRequest();
  }
  public grandService(type: any, type_index: any) {
    $("#services").modal("show");
    console.log("TYPE SELECTED", type);
    this.SelectedAccount.Data = type;
    this.SelectedAccount.Index = type_index;
    // this.SelectedAccount.account_id = type;
    console.log("TYPE SELECTED INDEX", this.SelectedAccount.Index);
  }
  public closeModal() {
    $("#services").modal("hide");
    $(".modal-backdrop").remove();
    this.SelectedAccount = {};
    this.AllocatedService = [];
    this.Note = '';
    this.ServiceList.forEach((type: any) => {
      // console.log("EACH", type );
      type.SelectAll = false;
    });
    // console.log("Close modal", this.ApprovedTypeList);
  }
  public grantServiceToAccount() {
    let data = {
      account_id: this.SelectedAccount.Data.account_id,
      account_modules: this.AllocatedService,
      note: this.Note,
    };
    this.ui.PostLoading = true;
    trekService
      .grantService(data)
      .then((res: any) => {
        flashService.Success("Service Granted", res.data.message);
        console.log("Response", res.data.data);
        // this.RequestList
        this.$set(this.RequestList, this.SelectedAccount.Index, res.data.data);
        this.closeModal();
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsModal).then(res => {
          this.errorsModal = res;
        });
        // flashService.Error("Error", "Error while adding Segment.");
      })
      .finally(() => {
        this.ui.PostLoading = false;
      });
  }
}
